var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section-definition',{attrs:{"title":"Coach Up"}}),_c('grade-coach-up',{attrs:{"coachup_id":_vm.coachup_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }